import styles from "./Header.module.css";
import { Link, useNavigate } from "react-router-dom";
import logo from "../../assets/images/Logo/logo.png";


function Header() {
  const navigate = useNavigate();

  return (
    <div className={styles.headerContainer}>
      <img
         src={logo}
         alt="Foodosia"
         onClick={() => navigate("/")}
         className={styles.logo}
      />
      <div>
        {/* Interne Links laufen über React Router und laden die Seite nicht neu. */}
        {/* Admin bewusst kein Navigationspunkt - nur direkt über /admin erreichbar. */}
        <Link to="/">Home</Link>
        <Link to="/kantine">Betriebskantine</Link>
        <Link to="/speiseplan">Speiseplan</Link>
        <Link to="/kontakt">Kontakt</Link>
      </div>
    </div>
  );
}

export default Header;
